(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valesstra-v2-announcement"]) return;
  try {
    
  if (!customElements.get('valesstra-announcement')) {
    customElements.define(
      'valesstra-announcement',
      class ValesstraAnnouncement extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';
          this.slides = Array.from(this.querySelectorAll('[data-v2-announcement-slide]'));
          this.status = this.querySelector('[data-v2-announcement-status]');
          this.index = 0;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.querySelector('[data-v2-announcement-previous]')?.addEventListener('click', () => this.show(this.index - 1, true));
          this.querySelector('[data-v2-announcement-next]')?.addEventListener('click', () => this.show(this.index + 1, true));
          this.addEventListener('pointerenter', () => this.pause());
          this.addEventListener('pointerleave', () => this.start());
          this.addEventListener('focusin', () => this.pause());
          this.addEventListener('focusout', (event) => {
            if (!this.contains(event.relatedTarget)) this.start();
          });
          document.addEventListener('visibilitychange', () => {
            if (document.hidden) this.pause();
            else this.start();
          });
          this.show(0, false);
          this.start();
        }

        disconnectedCallback() {
          this.pause();
        }

        show(index, announce) {
          if (!this.slides.length) return;
          this.index = (index + this.slides.length) % this.slides.length;
          this.slides.forEach((slide, slideIndex) => {
            const active = slideIndex === this.index;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', String(!active));
            const link = slide.querySelector('a');
            if (active) link?.removeAttribute('tabindex');
            else link?.setAttribute('tabindex', '-1');
          });
          if (announce && this.status) this.status.textContent = this.slides[this.index].textContent.trim();
        }

        start() {
          this.pause();
          if (this.dataset.autoRotate !== 'true' || this.slides.length < 2 || this.reducedMotion.matches) return;
          const speed = Math.max(Number(this.dataset.speed) || 6000, 5000);
          this.timer = window.setInterval(() => this.show(this.index + 1, false), speed);
        }

        pause() {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valesstra-v2-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeFooter = (footer) => {
      if (footer.dataset.v2DisclosureInitialized === 'true') return;
      footer.dataset.v2DisclosureInitialized = 'true';

      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const groups = [...footer.querySelectorAll('[data-v2-footer-group]')];

      const syncGroups = () => {
        groups.forEach((group) => {
          const summary = group.querySelector('summary');
          if (mobileQuery.matches) {
            group.open = false;
            summary?.removeAttribute('aria-disabled');
            summary?.removeAttribute('tabindex');
          } else {
            group.open = true;
            summary?.setAttribute('aria-disabled', 'true');
            summary?.setAttribute('tabindex', '-1');
          }
        });
      };

      syncGroups();
      mobileQuery.addEventListener('change', syncGroups);
    };

    const initializeAllFooters = (scope = document) => {
      scope.querySelectorAll('.v2-footer').forEach(initializeFooter);
    };

    initializeAllFooters();
    document.addEventListener('shopify:section:load', (event) => initializeAllFooters(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valesstra-v2-header"]) return;
  try {
    
  (() => {
    const initializeHeader = (root) => {
      if (root.dataset.v2Initialized === 'true') return;
      root.dataset.v2Initialized = 'true';

      const triggers = [...root.querySelectorAll('[data-v2-mega-trigger]')];
      const panels = [...root.querySelectorAll('[data-v2-mega-panel]')];
      const scrim = root.querySelector('[data-v2-mega-scrim]');
      let activeTrigger = null;

      const closeMega = (returnFocus = false) => {
        triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
        panels.forEach((panel) => { panel.hidden = true; });
        root.classList.remove('is-menu-open');
        if (scrim) scrim.hidden = true;
        if (returnFocus && activeTrigger) activeTrigger.focus();
        activeTrigger = null;
      };

      const openMega = (trigger) => {
        const panel = root.querySelector(`#${CSS.escape(trigger.dataset.v2MegaTrigger)}`);
        if (!panel) return;
        const wasOpen = trigger.getAttribute('aria-expanded') === 'true';
        closeMega(false);
        if (wasOpen) return;
        trigger.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        root.classList.add('is-menu-open');
        root.style.setProperty('--v2-scrim-top', `${root.getBoundingClientRect().bottom}px`);
        if (scrim) scrim.hidden = false;
        activeTrigger = trigger;
      };

      triggers.forEach((trigger) => trigger.addEventListener('click', () => openMega(trigger)));
      root.querySelectorAll('[data-v2-mega-close]').forEach((button) => button.addEventListener('click', () => closeMega(true)));
      if (scrim) scrim.addEventListener('click', () => closeMega(true));

      const dialog = root.querySelector('[data-v2-mobile-dialog]');
      const mobileTrigger = root.querySelector('[data-v2-mobile-open]');
      const mobileClose = root.querySelector('[data-v2-mobile-close]');
      const mobilePanels = [...root.querySelectorAll('[data-v2-mobile-panel]')];

      const showMobilePanel = (name) => {
        mobilePanels.forEach((panel) => {
          const active = panel.dataset.v2MobilePanel === name;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
        const activePanel = mobilePanels.find((panel) => panel.dataset.v2MobilePanel === name);
        activePanel?.querySelector('a, button')?.focus();
      };

      mobileTrigger?.addEventListener('click', () => {
        closeMega(false);
        dialog?.showModal();
        document.documentElement.classList.add('v2-mobile-menu-open');
        mobileTrigger.setAttribute('aria-expanded', 'true');
        showMobilePanel('root');
      });

      mobileClose?.addEventListener('click', () => dialog?.close());
      dialog?.addEventListener('close', () => {
        document.documentElement.classList.remove('v2-mobile-menu-open');
        mobileTrigger?.setAttribute('aria-expanded', 'false');
        mobileTrigger?.focus();
        showMobilePanel('root');
      });

      root.querySelectorAll('[data-v2-mobile-forward]').forEach((button) => {
        button.addEventListener('click', () => showMobilePanel(button.dataset.v2MobileForward));
      });

      root.querySelectorAll('[data-v2-mobile-back]').forEach((button) => {
        button.addEventListener('click', () => showMobilePanel('root'));
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && root.classList.contains('is-menu-open')) closeMega(true);
      });

      if (root.dataset.v2Home === 'true') {
        const updateScrolledState = () => root.classList.toggle('is-scrolled', window.scrollY > 20);
        updateScrolledState();
        window.addEventListener('scroll', updateScrolledState, { passive: true });
      }
    };

    const initializeAllHeaders = (scope = document) => {
      scope.querySelectorAll('[data-v2-header-root]').forEach(initializeHeader);
    };

    initializeAllHeaders();
    document.addEventListener('shopify:section:load', (event) => initializeAllHeaders(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valesstra-v2-product-rail"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeRail = (root) => {
      if (!root || root.dataset.v2RailReady === 'true') return;
      const viewport = root.querySelector('[data-v2-rail-viewport]');
      const item = root.querySelector('[data-v2-rail-item]');
      const progress = root.querySelector('[data-v2-rail-progress]');
      if (!viewport || !item) return;

      const update = () => {
        const scrollable = Math.max(viewport.scrollWidth - viewport.clientWidth, 0);
        const ratio = scrollable === 0 ? 1 : Math.min(1, (viewport.scrollLeft + viewport.clientWidth) / viewport.scrollWidth);
        root.style.setProperty('--v2-rail-progress', ratio);
      };

      const step = () => item.getBoundingClientRect().width + 1;
      root.querySelector('[data-v2-rail-previous]')?.addEventListener('click', () => viewport.scrollBy({ left: -step(), behavior: 'smooth' }));
      root.querySelector('[data-v2-rail-next]')?.addEventListener('click', () => viewport.scrollBy({ left: step(), behavior: 'smooth' }));
      viewport.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      root.dataset.v2RailReady = 'true';
      update();
    };

    document.querySelectorAll('[data-v2-product-rail]').forEach(initializeRail);
    document.addEventListener('shopify:section:load', (event) => initializeRail(event.target.querySelector('[data-v2-product-rail]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valesstra-v2-reviews"]) return;
  try {
    
  function initializeValesstraReviews(root = document) {
    root.querySelectorAll('[data-v2-reviews]').forEach((section) => {
      if (section.dataset.v2Ready === 'true') return;
      section.dataset.v2Ready = 'true';
      const list = section.querySelector('[data-review-list]');
      const template = section.querySelector('[data-review-template]');
      const more = section.querySelector('[data-review-more]');
      const status = section.querySelector('[data-review-status]');
      const sort = section.querySelector('[data-review-sort]');
      const filters = [...section.querySelectorAll('[data-review-filter]')];
      if (!list) return;
      const allRows = [...list.children, ...(template ? [...template.content.children].map((row) => row.cloneNode(true)) : [])];
      const desktopBatchSize = Number(more?.dataset.batchSize || 6);
      const mobileBatchSize = Number(more?.dataset.mobileBatchSize || 3);
      const batchSize = window.matchMedia('(max-width: 749px)').matches ? mobileBatchSize : desktopBatchSize;
      let activeFilter = 'all';
      let visibleCount = batchSize;
      const apply = () => {
        const rows = allRows.filter((row) => activeFilter === 'all' || row.dataset.rating === activeFilter);
        const sorted = [...rows].sort((a, b) => {
          if (sort?.value === 'highest') return Number(b.dataset.rating) - Number(a.dataset.rating) || Number(a.dataset.reviewIndex) - Number(b.dataset.reviewIndex);
          if (sort?.value === 'lowest') return Number(a.dataset.rating) - Number(b.dataset.rating) || Number(a.dataset.reviewIndex) - Number(b.dataset.reviewIndex);
          return Number(a.dataset.reviewIndex) - Number(b.dataset.reviewIndex);
        });
        const visibleRows = sorted.slice(0, visibleCount);
        list.replaceChildren(...visibleRows);
        if (more) more.hidden = visibleRows.length >= sorted.length;
        if (status) status.textContent = (status.dataset.template || '').replace('__SHOWN__', String(visibleRows.length)).replace('__TOTAL__', String(sorted.length));
      };
      filters.forEach((button) => button.addEventListener('click', () => {
        activeFilter = button.dataset.reviewFilter;
        visibleCount = batchSize;
        filters.forEach((candidate) => candidate.setAttribute('aria-pressed', String(candidate === button)));
        apply();
        list.focus({ preventScroll: true });
      }));
      sort?.addEventListener('change', () => { visibleCount = batchSize; apply(); });
      more?.addEventListener('click', () => { visibleCount += batchSize; apply(); });
      apply();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeValesstraReviews(), { once: true });
  else initializeValesstraReviews();
  document.addEventListener('shopify:section:load', (event) => initializeValesstraReviews(event.target));

  } catch(e) { console.error(e); }
})();
})();
